import { useState } from "react";
import { Button, Divider, Input, Modal } from "semantic-ui-react";
import { createPrearrival, getPrearrivalsBooking } from "services/prearrivals";

export default function SearchPopup(props: any): JSX.Element {
  const [error, setError] = useState({ message: '' })
  const [loading, setLoading] = useState(false)
  const { popup, setPopup, bookingFilter, setBookingFilter, setBookings } = props

  return (
    <>
      <Modal
        closeIcon
        style={{ width: "25rem" }}
        onClose={() => setPopup({ ...popup, searchBooking: false })}
        open={popup.searchBooking}
      >
        <Modal.Header className="text-center">Search By</Modal.Header>
        <Modal.Content className="text-center">
          {!error.message ?<></>: <div style={{color:'red', fontWeight:'600'}}>{error.message}</div>}
          <div>
            <Input
              name="bookingNumber"
              placeholder="Confirmation Number"
              value={bookingFilter.bookingNumber}
              onChange={(e, data) => setBookingFilter({ ...bookingFilter, [data.name]: data.value })}
            />
          </div>
          <Divider horizontal>Or</Divider>
          <div>
            <Input
              name="email"
              placeholder="Email"
              value={bookingFilter.email}
              onChange={(e, data) => setBookingFilter({ ...bookingFilter, [data.name]: data.value })}
            />
          </div>
          <Divider horizontal>Or</Divider>
          <div>
            <Input
              name="firstName"
              placeholder="First Name"
              value={bookingFilter.firstName}
              onChange={(e, data) => setBookingFilter({ ...bookingFilter, [data.name]: data.value })}
            />
          </div>
          <div>
            <Input
              name="lastName"
              placeholder="Last Name"
              value={bookingFilter.fullName}
              onChange={(e, data) => setBookingFilter({ ...bookingFilter, [data.name]: data.value })}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color='black' onClick={() => {
            setBookingFilter({
              bookingNumber: null,
              email: null,
              fullName: null,
            })
            // setFilter({ ...filter, filtering: false })
            setPopup({ ...popup, searchBooking: false })
            setLoading(false)
          }}>
            Cancel
          </Button>
          <Button
            content="Search booking"
            loading={loading && !error.message}
            disabled={loading && !error.message}
            onClick={async () => {
              try {
                setError({...error,message:''})
                setLoading(true)
                const queryString = Object.keys(bookingFilter)
                  .filter(key => {
                    return !!bookingFilter[key]
                  })
                  .map(key => {
                    return `${key}=${bookingFilter[key]}`
                  })
                  .join("&")
                const bookings = await getPrearrivalsBooking(`?${queryString}`, bookingFilter)

                setPopup({ ...popup, bookings: true })
                setBookings([...bookings])
                setLoading(false)
              } catch (err: any) {
                setError({ ...error, message: err.message })
              }
            }}
            color="yellow"
          />
        </Modal.Actions>
      </Modal>
      {props.children}
    </>

  )
}
